import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({ title, description, image, slug, children, noIndex }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
      favicon: file(name: { eq: "favicon" }) {
        publicURL
      }
      social: file(name: { eq: "timsmith-social" }) {
        publicURL
      }
    }
  `);

  return (
    <Helmet
      htmlAttributes={{ lang: `en` }}
      titleTemplate={`%s | ${data.site.siteMetadata.title}`}
    >
      <link rel='shortcut icon' href={data.favicon.publicURL} />
      <link rel="canonical" href={`${data.site.siteMetadata.siteUrl}/${slug}`} />
      <link rel="alternate" href={`${data.site.siteMetadata.siteUrl}`} hreflang="x-default" />
      <link rel="alternate" href={`${data.site.siteMetadata.siteUrl}`} hreflang="en-IN" />
      <link rel="alternate" href="https://vymo.com/us" hreflang="en-US" />

      <title>{title}</title>
      <meta
        name='title'
        content={`${title} | ${data.site.siteMetadata.title}`}
      />
      <meta
        name='description'
        content={description || data.site.siteMetadata.description}
      />
      <meta 
        name='og:title' 
        content={`${title} | ${data.site.siteMetadata.title}`}
      />
      <meta
        name='og:description'
        content={description || data.site.siteMetadata.description}
      />
      <meta name='site_name' content={data.site.siteMetadata.title} />
      <meta property='og:image' name='og:image' content={image || 'https://vymo.com/img/us/preview.avif'} />
      <meta property='og:image:secure_url' name='og:image:secure_url' content={image || 'https://vymo.com/img/us/preview.avif'} />
      <meta 
        name='twitter:title' 
        content={`${title} | ${data.site.siteMetadata.title}`} 
      />
      <meta
        name='twitter:description'
        content={description || data.site.siteMetadata.description}
      />
      <meta name='twitter:image' content={image || 'https://vymo.com/img/us/preview.avif'} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:site' content='@vymo' />
      <meta name='twitter:creator' content='@vymo' />
      <meta name='og:type' content='website' />
      <meta name='og:url' content={`${data.site.siteMetadata.siteUrl}/${slug}`} />
      <meta name='og:site_name' content={data.site.siteMetadata.title} />
      {children}
      {noIndex && (
        <meta name="robots" content="noindex, nofollow" />
      )}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  slug: PropTypes.string,
  children: PropTypes.node,
};

export default SEO;
